import {
  Box, Grid, FormControlLabel, Checkbox, makeStyles
} from '@material-ui/core';
import React, { useCallback } from 'react';
import { useRouteMatch, Switch, Route, useHistory } from 'react-router-dom';
import WasteJobsOverviewDashboard from './Jobs/OverviewDashboard';
import BinDeliveriesDashboard from './Jobs/BinDeliveriesDashboard';
import MissedBinsDashboard from './Jobs/MissedBinsDashboard';
import WasteNavBar from '../PageElements/WasteNavBar';
import dateFormat from 'date-fns/format';

interface JobsLinkProps {
  to: string
  label: string
}

const JobsLink: React.FC<JobsLinkProps> = (props) => {
  const classes = useStyles();
  const history = useHistory();

  // remove potential double slash
  const cleanedLinkTo = props.to.replace(/([^:]\/)\/+/g, "$1");

  let match = useRouteMatch(cleanedLinkTo);

  const navigate = useCallback(
    () => {
      history.push(cleanedLinkTo)
    },
    [cleanedLinkTo, history],
  );

  return (
    <FormControlLabel
      control={<Checkbox color="primary" checked={match?.isExact || false} />}
      label={props.label}
      onClick={navigate}
      className={classes.jobsLink}
    />
  );
}

const WasteJobsDashboard = () => {
  const classes = useStyles();
  let { path, url } = useRouteMatch();
  return (
    <>
      <WasteNavBar>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Grid container xs spacing={1} alignItems="center">
            <Grid item>
              <JobsLink to={`${url}`} label="Overview" />
            </Grid>
            <Grid item>
              <JobsLink to={`${url}/bin-deliveries`} label="Bin Deliveries" />
            </Grid>
            <Grid item>
              <JobsLink to={`${url}/missed-bins`} label="Missed Bins" />
            </Grid>
          </Grid>
          <Box className={classes.dateText}>
            {dateFormat(new Date(), "cccc do LLLL, y")}
          </Box>
        </Box>
      </WasteNavBar>
      <Box mx={4} my={4}>
        <Switch>
          <Route exact path={path}>
		  <iframe width="100%" height="720" allowfullscreen="true" src="https://apps.powerapps.com/play/12e28902-1828-4047-b1ac-58fc73e567c3"/>
            <WasteJobsOverviewDashboard />
          </Route>
          <Route path={`${path}/bin-deliveries`}>
            <BinDeliveriesDashboard />
          </Route>
          <Route path={`${path}/missed-bins`}>
            <MissedBinsDashboard />
          </Route>
        </Switch>
      </Box>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  dateText: {
    textAlign: "right",
    fontSize: "18px",
    lineHeight: "32px",
    color: theme.palette.info.main,
  },
  jobsLink: {
    fontSize: "16px",
    lineHeight: "24px",
    textDecoration: "none",
    color: theme.palette.info.main,
  },
}));

export default WasteJobsDashboard;